import { render, staticRenderFns } from "./VTabContent.vue?vue&type=template&id=ced608f8&"
import script from "./VTabContent.vue?vue&type=script&lang=js&"
export * from "./VTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports